// extracted by mini-css-extract-plugin
module.exports = {"footerBox":"style_footerBox__15EKR","item":"style_item__3Zbe7"};